import type { DiseaseType, FindingType } from "../mappers";
import type { DiseaseRecommender } from ".";
import type { DiseasePredictionModel } from "./disease-prediction-model";

export class ModelBasedRecommender implements DiseaseRecommender {
  constructor(
    private readonly model: DiseasePredictionModel,
    private readonly threshold: number,
  ) {}

  recommend(findings: FindingType[]): DiseaseType[] {
    const scores = this.model.predict(findings);
    return Object.entries(scores)
      .filter(([, score]) => score >= this.threshold)
      .sort(([, a], [, b]) => b - a)
      .map(([disease]) => disease as DiseaseType);
  }
}
